import React, { useState } from 'react';
import { stringify } from 'qs';
import { Box, Button, Text, useSnackbar } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { EXISTING_PLAN_ERR_MSG } from 'components/shop/MobilePlans/constants/changePlan.constants';
import { useChangePlanDetails } from 'components/shop/MobilePlans/providers';
import { ChangePlanActionTypes } from 'components/shop/MobilePlans/reducer/changePlan.reducer';
import ChoiceBoxSelector from '../ChoiceBoxSelector';

const ChangePlanAccountSelectionContent = () => {
  const [selectedAccountNumber, setSelectedAccountNumber] =
    useState<string>('');
  const { showSnackbar } = useSnackbar();
  const { userInfoUpdate, dispatch } = useChangePlanDetails();
  const {
    accounts,
    redirect,
    eligibleLines: changePlanEligibleLInes,
  } = userInfoUpdate;

  const handleClick = () => {
    const eligibleLines = changePlanEligibleLInes?.filter(
      (lines) => lines?.accountNumber === selectedAccountNumber,
    );
    if (eligibleLines && eligibleLines?.length === 1 && redirect) {
      const { path, planId } = redirect;
      if (eligibleLines[0].offerId === planId) {
        showSnackbar({
          text: EXISTING_PLAN_ERR_MSG,
          variant: 'error',
        });
      } else {
        const redirectLink = `${path}?${stringify(
          {
            lineNumber: eligibleLines[0].lineNumber,
            action: 'changePlan',
            offerId: planId,
            tab: 'endless_plans',
          },
          { arrayFormat: 'comma' },
        )}`;
        window.location.assign(redirectLink);
      }
    } else {
      dispatch({
        type: ChangePlanActionTypes.SetManageLines,
        payload: {
          selectedAccount: selectedAccountNumber,
        },
      });
    }
  };

  const items =
    accounts?.map(({ accountNumber, firstName, lastName }) => ({
      id: accountNumber,
      label: `${firstName} ${lastName}`,
      subLabel: `#${accountNumber}`,
    })) || [];

  return (
    <Box pt="s4">
      <Text variant="subheadingM">Select your account</Text>
      <LinkRegion isNotTracked>
        <ChoiceBoxSelector
          items={items}
          selectedItem={selectedAccountNumber}
          setSelectedItem={setSelectedAccountNumber}
        />
        <LinkRegion regionId="productDetails.selectAccount">
          <Button
            variant="primary"
            fullWidth
            onClick={handleClick}
            disabled={!selectedAccountNumber}
            mb="s2"
          >
            Continue
          </Button>
        </LinkRegion>
      </LinkRegion>
    </Box>
  );
};

export default ChangePlanAccountSelectionContent;
